<script setup>
import { computed, getCurrentInstance } from 'vue';
import Tooltip from './Tooltip.vue';
import ProBadge from './ProBadge.vue';

const props = defineProps({
    hints: {
        type: String,
        default: ''
    },
    for: {
        type: String,
        default: ''
    },
    locked: {
        type: Boolean,
        default: false,
    },
    semibold: {
        type: Boolean,
        default: false,
    }
});

const theFor = computed( () => {
    const instance = getCurrentInstance();
    return props.for || instance.parent.props.id || 'formychat-element-' + instance.parent.uid;
})

const locked = computed( () => {
    return props.locked && ! formychat_admin_vars.is_premium ? 'formychat-locked child:pointer-events-none opacity-60' : null
})

</script>

<template>
    <div class="flex items-center gap-3 w-fit" v-bind="$attrs">
        <label class="tracking-wide text-sm text-slate-600" :for="theFor" :class="[locked, props.semibold ? 'font-semibold text-slate-800' : 'font-normal']">
            <slot/>
        </label>
        <Tooltip v-if="props.hints">
            {{ props.hints }}
        </Tooltip>
        <ProBadge v-if="locked" />
    </div>
</template>